import logoGuido from '@/assets/images/guido_bot.png'
import styles from './styles.module.css'

export const GuidoAvatarAtom = () => {
    return (
        <div className={styles.container_logo}>
            <img src={logoGuido} className={styles.logo_guido} />
        </div>
    )
}
